import { render, staticRenderFns } from "./NewPasswordLayout.vue?vue&type=template&id=e8a74168"
import script from "./NewPasswordLayout.vue?vue&type=script&lang=js"
export * from "./NewPasswordLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports